import { apiClient } from "../../../config/axios.config";
import type { Response } from "../../../types/api.types";
import type { GetAnalyticsResponse } from "../dtos/response/analytis.response";

const model = "/v1/analytics";

export const getAnalytics = async (): Promise<Response<GetAnalyticsResponse>> => {
  const { data } = await apiClient.get(`${model}`);
  return data;
};
